import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';

const reactAppData = window.rpReactPlugin || { appSelector: '#root' }
const { appSelector } = reactAppData
const appAnchorElement = document.querySelector(appSelector)

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  appAnchorElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
